class GartnerPi_Carousel {
  constructor(options) {
    Object.assign(this, options)
    // containerSelector, ratingSelector, swiperSelector, swiperInitialized, visibleSelector, buttonContainerSelector, halfStarSelector, fullStarSelector,finishedPopulatingReviewsPartialClass
    this.hasSwiperObserver = false
    this.buttonsInitialized = false
    this.finishedPopulatingReviews = false
    this.starValueLabels = false
    this.halfStarClass = ""
    this.fullStarClass = ""
    this.nodeCount = 0
    this.containerElement = null
    this.init()
  }

  init() {
    this.containerElement = document.querySelector(this.containerSelector)
    if (!this.containerElement) return
    const buttonContainerSelectorTrimmed = this.buttonContainerSelector.replace(/^\./, "")
    const ratingSelectorTrimmed = this.ratingSelector.replace(/^\./, "")
    const containerObserver = new MutationObserver((mutations) => {
      const swiperInitializedTrimmed = this.swiperInitialized.replace(/^\./, "")
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (
            !this.finishedPopulatingReviews &&
            node.nodeType === Node.ELEMENT_NODE &&
            node.classList.toString().includes(this.finishedPopulatingReviewsPartialClass)
          ) {
            // reviews have been loaded into DOM
            this.finishedPopulatingReviews = true
            this.detailedDescriptionReviewBatch()
            this.starAriaLabelsBatchByValue()
          }
          if (
            !this.hasSwiperObserver &&
            node.nodeType === Node.ELEMENT_NODE &&
            node.outerHTML.includes(swiperInitializedTrimmed)
          ) {
            this.hasSwiperObserver = true
            const swiperElement = node.querySelector(this.swiperSelector)
            if (swiperElement) {
              this.initSwiperSlideObserver(swiperElement)
            }
          }
          if (
            !this.buttonsInitialized &&
            node.nodeType === Node.ELEMENT_NODE &&
            node.matches(this.buttonContainerSelector)
          ) {
            this.buttonsInitialized = true
            this.addTabIndexesToButtons(node)
          }
        })
      })
    })
    // Start observing
    containerObserver.observe(this.containerElement, {
      childList: true,
      subtree: true,
    })
  }
  getDynamicStarSelectorClasses(node) {
    return
    const halfStar = node.querySelector(this.halfStarSelector)
  }
  setTabIndex(element, className) {
    if (element && element.className.startsWith(className)) {
      element.setAttribute("tabindex", "0")
      return true
    }
    return false
  }

  addTabIndexesToButtons(widget) {
    const buttons = widget.querySelectorAll('[aria-label="Previous"], [aria-label="Next"]')
    buttons.forEach((button) => {
      const arrowControl = button.firstElementChild
      if (!this.setTabIndex(arrowControl, "ArrowControl__ArrowControlContainer")) {
        // If the tabindex was not set on the arrowControl, set it on the button
        if (!arrowControl) {
          const observer = new MutationObserver((mutationsList, observer) => {
            const arrowControl = button.firstElementChild
            if (this.setTabIndex(arrowControl, "ArrowControl__ArrowControlContainer")) {
              observer.disconnect() // Stop observing when the first child is added
            }
          })

          // Start observing the button for the addition of new child nodes
          observer.observe(button, { childList: true })
        } else {
          this.setTabIndex(button, "")
        }
      }
    })
  }
  detailedDescriptionReviewBatch() {
    const reviewNodes = this.containerElement.querySelectorAll('[class^="ReviewAlignContainer__Container"]')
    reviewNodes.forEach((reviewNode) => {
      this.detailedDescriptionReviewSingle(reviewNode)
    })
  }
  detailedDescriptionReviewSingle(node) {
    // detailed description link for "posted on G2" link
    const targetLink = node.querySelector('[class^="ReviewLinkContainer__Link"]')
    const reviewTitleParent = node.previousElementSibling
    const reviewTitleItem = node.querySelector(".es-review-content-title")
    if (!targetLink || !reviewTitleItem) return

    let reviewTitleText = reviewTitleItem?.textContent
    const reviewTitleSnippet = reviewTitleText?.split(" ").slice(0, 5).join(" ")
    const ellipsis = reviewTitleText.split(" ").length > 5 ? "..." : ""
    targetLink.setAttribute(
      "aria-label",
      `Review posted on G2 for: ${reviewTitleSnippet.replace(/&quot;/g, "")}${ellipsis} `,
    )
  }

  initSwiperSlideObserver(swiper) {
    const swiperSlideObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE && node.classList?.contains("swiper-slide")) {
            node.setAttribute("aria-hidden", node.classList?.contains("swiper-slide-visible") ? "false" : "true")
          }
        })
        if (mutation.type === "attributes") {
          // change in style due to resize/mobile/next/prev actions
          const checkSwipeUnits = swiper.querySelectorAll(".swiper-slide")
          checkSwipeUnits?.forEach((unit) => {
            unit.setAttribute("aria-hidden", true)
            if (unit.classList?.contains("swiper-slide-visible")) {
              unit.setAttribute("aria-hidden", false)
            }
          })
        }
      })
    })

    // Start observing for .swiper-slide-visible changes
    swiperSlideObserver.observe(swiper, {
      childList: true,
      attributes: true,
      attributeFilter: ["class", "style"],
    })
  }

  applyAriaLabels(groupSelector, message) {
    const group = this.containerElement.querySelectorAll(groupSelector)
    if (group.length) {
      group.forEach((star) => {
        const ratingParent = star.closest(this.ratingSelector)
        if (ratingParent) {
          ratingParent.setAttribute("aria-label", message)
        }
      })
    }
  }

  findDynamicClasses() {
    const unfilledItems = this.containerElement.querySelectorAll(".es-carousel-layout .es-rating-stars-item-unfilled")
    const dynamicClasses = { none: null, fifty: null, hundred: null }
    const clipPathToProperty = { none: "none", 50: "fifty", 100: "hundred" }

    for (let unfilledItem of unfilledItems) {
      const children = Array.from(unfilledItem.children)
      for (let child of children) {
        this.findDynamicClassForElement(child, dynamicClasses, clipPathToProperty)
        if (Object.values(dynamicClasses).every(Boolean)) {
          return [dynamicClasses.none, dynamicClasses.fifty, dynamicClasses.hundred]
        }
      }
    }
    return [dynamicClasses.none, dynamicClasses.fifty, dynamicClasses.hundred]
  }

  findDynamicClassForElement(element, dynamicClasses, clipPathToProperty) {
    const className =
      this.findPrecedingClass(element, "es-rating-item-unfilled") ||
      this.findPrecedingClass(element, "es-rating-item-filled")
    if (className) {
      const clipPathValue = this.logClipPath(className)
      const property = clipPathToProperty[clipPathValue]
      if (property && !dynamicClasses[property]) {
        dynamicClasses[property] = className
      }
    }
  }

  logClipPath(className) {
    className = className.replace(/^\./, "")
    const tempElement = document.createElement("div")
    tempElement.className = className
    document.body.appendChild(tempElement)
    const computedStyles = window.getComputedStyle(tempElement)
    let clipPath = computedStyles.getPropertyValue("clip-path")

    if (clipPath && clipPath !== "none") {
      const values = clipPath.match(/-?[\d\.]+/g)
      if (values && values.length > 1) {
        clipPath = values[1]
      }
    }
    document.body.removeChild(tempElement)
    return clipPath
  }

  findPrecedingClass(node, classRef) {
    const classes = node.className.split(" ")
    const index = classes.indexOf(classRef)
    return index > 0 ? classes[index - 1] : null
  }

  starAriaLabelsBatchByValue() {
    let dynamicClasses = this.findDynamicClasses() || []
    if (dynamicClasses.length < 2) return
    dynamicClasses = dynamicClasses.map((className) => "." + className) // add dot to beginning of class names

    const [classOne, classTwo] = dynamicClasses

    const starCount = 5
    const fiveStarSelector = `.es-rating-stars-item-filled:last-child`
    this.applyAriaLabels(fiveStarSelector, `5 stars`)

    for (let i = 1; i <= starCount; i++) {
      const emptyStarSelector = `.es-rating-stars-item-unfilled:nth-child(${i}) > ${classOne}:first-child + *:not(${classTwo})`
      const halfStarSelector = `.es-rating-stars-item-unfilled:nth-child(${i}) > ${classTwo}:last-child`
      this.applyAriaLabels(emptyStarSelector, `${i - 1} stars`)
      this.applyAriaLabels(halfStarSelector, `${i - 1}+ stars`)
    }
  }
}
export { GartnerPi_Carousel }
